document.addEventListener('DOMContentLoaded', function() {
	// Handle button clicks with data-modal-id
	document.addEventListener('click', function(e) {
		// Allow links inside modal content to work normally
		const clickedLink = e.target.closest('a');
		const insideModalContent = e.target.closest('.modal-content');
		
		// If clicking a link inside modal content, let it work
		if (clickedLink && insideModalContent && !clickedLink.hasAttribute('data-modal-id')) {
			// Let links inside modal work normally (unless they're modal triggers)
			return;
		}
		
		// Close modal on close button click
		if (e.target.closest('.modal-close')) {
			e.preventDefault();
			closeModal(e.target.closest('.modal-popup'));
			return;
		}
		
		// Close modal on overlay click
		if (e.target.classList.contains('modal-overlay')) {
			closeModal(e.target.closest('.modal-popup'));
			return;
		}
		
		// Open modal - only if clicking trigger button (not inside modal content unless it's a modal trigger)
		const trigger = e.target.closest('[data-modal-id]');
		if (trigger && !trigger.classList.contains('modal-popup')) {
			e.preventDefault();
			const modalId = trigger.getAttribute('data-modal-id');
			openModal(modalId);
		}
	});
	
	// Close modal on escape key
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape') {
			const activeModal = document.querySelector('.modal-popup.is-active');
			if (activeModal) {
				closeModal(activeModal);
			}
		}
	});
	
	function openModal(modalId) {
		const modal = document.querySelector(`.modal-popup[data-modal-id="${modalId}"]`);
		if (modal) {
			const maxWidth = modal.getAttribute('data-max-width');
			if (maxWidth) {
				const modalContent = modal.querySelector('.modal-content');
				if (modalContent) {
					modalContent.style.maxWidth = maxWidth;
				}
			}
			modal.classList.add('is-active');
			document.body.classList.add('modal-open');
			document.body.style.overflow = 'hidden';
			
			// Reinitialize Contact Form 7 inside the modal
			if (typeof wpcf7 !== 'undefined' && wpcf7.init) {
				const cf7Forms = modal.querySelectorAll('.wpcf7 > form');
				cf7Forms.forEach(function(form) {
					// Only initialize if not already initialized
					if (!form.wpcf7) {
						wpcf7.init(form);
					}
					
					// Reset the form
					form.reset();
					
					// Clear validation messages
					const responseOutput = form.querySelector('.wpcf7-response-output');
					if (responseOutput) {
						responseOutput.style.display = '';
						responseOutput.textContent = '';
						responseOutput.setAttribute('aria-hidden', 'true');
					}
					
					// Remove validation error classes
					form.querySelectorAll('.wpcf7-not-valid').forEach(function(field) {
						field.classList.remove('wpcf7-not-valid');
					});
					
					// Remove validation error messages
					form.querySelectorAll('.wpcf7-not-valid-tip').forEach(function(tip) {
						tip.remove();
					});
					
					// Remove form state classes
					form.classList.remove('sent', 'failed', 'invalid', 'spam', 'aborted');
				});
			}
		}
	}
	
	function closeModal(modal) {
		if (modal) {
			modal.classList.remove('is-active');
			document.body.classList.remove('modal-open');
			document.body.style.overflow = '';
		}
	}
});
